import { Injectable } from '@angular/core';

@Injectable()
export class LoggingService {
	/**
	 * Handle the error returned from the API and return a Promise reject with error message
	 * @param error
	 */
	handleError(error: any): Promise<any> {
		//Log error to console
		console.error('An error occurred', error);

		if (error.status == 403) {
			return Promise.reject(error.statusText);
		}

		//If error doesnt have a URL property then the conection to API failed
		if (error.url == null) {
			return Promise.reject('Network Error Occured');
		}

		//Create error object
		let errorObj;
		//If erro object creation fails return the whole error
		try {
			errorObj = error.error;
		} catch (e) {
			console.log(e);
			return Promise.reject(error);
		}

		//Init error message as either the message part of the object or if that property is null the whole object
		let errorMsg = errorObj.Message || errorObj;
		//Build the error message from the model state errors
		for (const modelError in errorObj.ModelState) {
			if (errorObj.ModelState.hasOwnProperty(modelError)) {
				errorMsg += '<br>&emsp;-&nbsp;' + errorObj.ModelState[modelError];
			}
		}

		return Promise.reject(errorMsg);
	}

	/**
	 * Handle a XHR request error and return a error message
	 * @param error
	 */
	handleErrorXhr(error: any): any {
		console.error('An error occurred', error);
		if (error === '') {
			return 'Network Error Occured';
		}
		const errorObj = JSON.parse(error);
		let errorMsg = errorObj && errorObj.Message;
		for (const modelError in errorObj.ModelState) {
			if (errorObj.ModelState.hasOwnProperty(modelError)) {
				errorMsg += '<br>&emsp;-&nbsp;' + errorObj.ModelState[modelError];
			}
		}

		return errorMsg;
	}


}



// WEBPACK FOOTER //
// ./src/app/services/logging/logging.service.ts